import { OrganizationSelectCard } from "@/features/session/components/OrganizationSelectCard";
import { ProductLoginCard } from "@/features/session/components/ProductLoginCard";
import { OrganizationSelectFilterCacheProvider } from "@/features/session/providers/OrganizationSelectFilterCacheProvider";
import { useTokenClaims } from "@/hooks/useTokenClaims";
import { Stack } from "@mui/material";
import { useState } from "react";

const OrganizationSelectPage = () => {
  // Pre-select the org of the current impersonation session (from the access-token claims)
  // so its radio is filled on load; empty for a plain admin session with no active org.
  const { organizationId } = useTokenClaims();
  const [selectedOrgId, setSelectedOrgId] = useState(organizationId ? String(organizationId) : "");
  const [selectedProductId, setSelectedProductId] = useState("");

  return (
    <OrganizationSelectFilterCacheProvider>
      <Stack flexDirection="row" gap={3}>
        <OrganizationSelectCard selectedOrgId={selectedOrgId} onSelectOrg={setSelectedOrgId} sx={{ flex: 1, minWidth: 0, height: "100%" }} />
        <ProductLoginCard
          organizationId={selectedOrgId}
          selectedProductId={selectedProductId}
          onSelectProduct={setSelectedProductId}
          sx={{ flex: 1, minWidth: 0, maxWidth: 420, height: "100%", gap: 3 }}
        />
      </Stack>
    </OrganizationSelectFilterCacheProvider>
  );
};

export default OrganizationSelectPage;
